/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateDailyUserUsageLimit200ResponseReissueOneOf
 */
export interface UpdateDailyUserUsageLimit200ResponseReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseReissueOneOf
     */
    'cardType': UpdateDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof UpdateDailyUserUsageLimit200ResponseReissueOneOf
     */
    'expiredDate': string;
}

export const UpdateDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type UpdateDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum = typeof UpdateDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum[keyof typeof UpdateDailyUserUsageLimit200ResponseReissueOneOfCardTypeEnum];


